import * as d3 from 'd3';

const MAX_EARNINGS_FOR_SLIDER = 120000;
const MAX_STUDENT_POPULATION_FOR_SLIDER = 50000;
const MAX_NET_PRICE_FOR_SLIDER = 45000;

const CONTROL_TYPES = {
  1: 'Public',
  2: 'Private Nonprofit',
  3: 'Private for Profit',
};

const PROJECTION = d3
  .geoAlbersUsa()
  .fitSize([960 / 5, 600 / 5])
  .scale(1280 / 5)
  .translate([480 / 5, 300 / 5]);

export {
  CONTROL_TYPES,
  MAX_EARNINGS_FOR_SLIDER,
  MAX_STUDENT_POPULATION_FOR_SLIDER,
  MAX_NET_PRICE_FOR_SLIDER,
  PROJECTION,
};



// WEBPACK FOOTER //
// ./src/App/Constants.js